export enum TemplateType {
  Default,
  MultiAnswerQuestion,
  LastReview,
  SuperFunds
}
